import { render } from "./Nav.vue?vue&type=template&id=0ca1c5b7&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=0ca1c5b7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ca1c5b7"

export default script